<template>
  <div id="home">
    <section role="banner" id="banner" class="bg-grey home">
      <transition name="fade">
        <div v-show="bannerImage.desktop" class="banner-image ff-mobile-hide" :style="'background-image: url(' + bannerImage.desktop + ');'"></div>
      </transition>
      <transition name="fade">
        <div v-show="bannerImage.tablet" class="banner-image ff-desktop-hide ff-hide ff-sm-hide" :style="'background-image: url(' + bannerImage.tablet + ');'"></div>
      </transition>
      <transition name="fade">
        <div v-show="bannerImage.mobile" class="banner-image ff-desktop-hide ff-md-hide" :style="'background-image: url(' + bannerImage.mobile + ');'"></div>
      </transition>
      <div class="banner-tag-and-prompt" :class="{'is-hidden': hideOnScroll}">
        <div class="banner-tagline" :class="'tag-' + bannerColor">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 20" v-bind:svg-inline="''" v-bind:title="'CSBP Lab. Extract Value.'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#FFF"><path d="M2.1 17.7C.7 16.2 0 13.8 0 10.6c0-6.2 3-9.3 8.9-9.3.9 0 1.8.1 2.7.3.9.2 1.6.4 2.2.7.5.3.7.5.7.8 0 .2-.1.6-.3 1-.2.4-.4.7-.7 1-.3.3-.5.5-.7.5-.1 0-.3-.1-.6-.2-.4-.2-.8-.3-1.4-.4-.5-.1-1.2-.2-1.9-.2-1.6 0-2.7.5-3.5 1.5s-1.1 2.5-1.1 4.4c0 4 1.5 6 4.6 6 .8 0 1.5-.1 2.1-.2.6-.2 1.2-.4 1.7-.6.3-.1.5-.2.6-.2.3 0 .5.1.8.4.2.3.4.6.6 1 .2.4.2.7.2.8 0 .5-.3.9-.9 1.2-.6.3-1.4.6-2.3.7-1 .2-1.9.2-2.7.2-3.2 0-5.4-.8-6.9-2.3zM18.8 19.6c-.9-.2-1.7-.6-2.2-.9-.5-.3-.7-.7-.7-1 0-.3.1-.6.3-.9.2-.4.4-.7.7-1 .3-.3.5-.4.7-.4.1 0 .4.1.7.3.6.3 1.1.5 1.5.7.5.2 1 .2 1.6.2.7 0 1.3-.1 1.8-.4.5-.3.7-.7.7-1.4 0-.6-.2-1-.7-1.3-.5-.3-1.2-.7-2.2-1.1l-1.2-.5c-1.1-.5-2-1.2-2.6-2-.6-.8-1-1.9-1-3.3 0-1.2.3-2.2.9-3s1.4-1.4 2.3-1.8c1-.4 2-.6 3.1-.6.9 0 1.7.1 2.5.3.7.2 1.3.4 1.7.7.4.3.6.6.6.8 0 .2-.1.6-.2.9s-.4.7-.6 1c-.2.3-.4.4-.6.4-.1 0-.2 0-.4-.1S25.1 5 25 5c-.6-.2-1.3-.3-2-.3-.9 0-1.6.1-1.9.4-.4.3-.5.6-.5 1 0 .5.1.8.4 1.1.2.3.6.5.9.7.4.2.9.4 1.6.7 1 .4 1.8.8 2.5 1.2.6.4 1.2.9 1.7 1.6.5.7.7 1.6.7 2.7 0 1.3-.3 2.5-.9 3.3-.6.9-1.3 1.5-2.2 1.9-.9.4-1.9.6-2.9.6-1.5.1-2.6 0-3.6-.3zM30.9 19.5c-.2-.2-.3-.4-.3-.8V2.5c0-.4.1-.6.3-.8.2-.2.4-.2.8-.2H37c2.2 0 3.8.4 4.8 1.2 1 .8 1.5 2 1.5 3.4 0 .9-.3 1.7-.8 2.4s-1.2 1.3-2.1 1.6v.1c1 .2 1.9.7 2.6 1.5.7.8 1 1.7 1 2.8 0 1.7-.6 3-1.7 4-1.1.9-2.8 1.4-5 1.4h-5.7c-.2-.1-.5-.2-.7-.4zm5.7-10.8c.8 0 1.4-.2 1.8-.6.4-.4.7-.8.7-1.4 0-1.3-.8-1.9-2.4-1.9h-1.9v3.9h1.8zm.8 7.7c.8 0 1.4-.2 1.8-.6.4-.4.6-.9.6-1.6s-.2-1.2-.7-1.5c-.5-.3-1.2-.5-2.1-.5h-2.2v4.2h2.6zM46.3 19V2.5c0-.4.1-.6.3-.8.2-.2.4-.2.8-.2H53c1.7 0 3.1.4 4.4 1.2 1.3.8 1.9 2.3 1.9 4.6 0 1.5-.4 2.7-1.1 3.6-.7.8-1.6 1.4-2.5 1.7s-1.7.4-2.5.4h-2.8v6c0 .6-.5.8-1.6.8h-.9c-1.1 0-1.6-.2-1.6-.8zm6.5-9.6c.6 0 1.2-.2 1.6-.5s.7-.9.7-1.8-.2-1.5-.7-1.8c-.5-.3-1-.5-1.6-.5h-2.4v4.6h2.4zM68.3 19.5c-.2-.2-.3-.4-.3-.8V2.2c0-.6.5-.8 1.6-.8h.9c1.1 0 1.6.3 1.6.8v14.1h5.8c.3 0 .5.1.6.3.1.2.2.5.2 1v.8c0 .5-.1.8-.2 1-.1.2-.3.3-.6.3h-8.8c-.3.1-.6 0-.8-.2zM81 19c-.6-.7-.9-1.6-.9-2.8 0-1.4.5-2.6 1.6-3.5 1-.9 3.1-1.4 6.1-1.4v-.9c0-.5-.2-.9-.5-1.1-.3-.2-.9-.4-1.6-.4-.7 0-1.2.1-1.7.2s-.9.3-1.2.4c-.4.2-.6.2-.6.2-.2 0-.4-.1-.6-.4l-.6-.9c-.2-.3-.2-.6-.2-.8 0-.3.2-.6.7-.9.4-.3 1.1-.5 1.8-.7.8-.2 1.6-.3 2.6-.3 2 0 3.5.4 4.4 1.2.9.8 1.4 1.9 1.4 3.2V15c0 .8 0 1.4.1 1.8 0 .4.1.9.2 1.4.1.2.1.4.1.6 0 .3-.4.5-1.1.6-.7.1-1.4.2-1.9.2-.3 0-.5-.1-.7-.4-.1-.3-.2-.5-.3-.8-.1-.3-.1-.5-.1-.6-.1.2-.3.4-.6.7-.3.3-.8.6-1.3.9-.7.5-1.4.6-2.1.6-1.4 0-2.4-.3-3-1zm5.7-2.5c.4-.3.8-.7 1-1.2v-1.4c-2.5 0-3.7.6-3.7 1.9 0 .3.1.6.3.8.2.2.6.3 1 .3.5 0 1-.1 1.4-.4zM100.4 19.4c-.6-.4-1.1-.8-1.4-1.4-.1.6-.2.9-.3 1.1-.1.3-.2.4-.5.5-.2.1-.6.1-1.1.1h-.3c-1.1 0-1.6-.3-1.6-.8V.8c0-.6.5-.8 1.6-.8h.7c1.1 0 1.6.3 1.6.8v5.8c.8-.5 1.7-.8 2.7-.8 1.8 0 3.2.6 4.1 1.9 1 1.3 1.5 3 1.5 5.2 0 1.5-.2 2.8-.6 3.8s-1 1.9-1.8 2.4c-.8.6-1.6.8-2.6.8-.7.1-1.4-.1-2-.5zm3.1-6.5c0-2.7-.8-4-2.5-4-.6 0-1.3.2-1.9.5v5.9c.6 1 1.3 1.5 2.2 1.5 1.5 0 2.2-1.3 2.2-3.9zM109.2 19v-2.4c0-.6.5-.8 1.6-.8h.9c1.1 0 1.6.3 1.6.8V19c0 .6-.5.8-1.6.8h-.9c-1 0-1.6-.2-1.6-.8zM129 19.5c-.2-.2-.3-.4-.3-.8V2.5c0-.4.1-.6.3-.8s.4-.2.8-.2h9.4c.3 0 .5.1.6.3.1.2.2.5.2 1v.8c0 .5-.1.8-.2 1-.1.2-.3.3-.6.3h-6.3v3.8h5.6c.3 0 .5.1.6.3.1.2.2.5.2 1v.8c0 .5-.1.8-.2 1-.1.2-.3.3-.6.3h-5.6v4.3h6.3c.3 0 .5.1.6.3.1.2.2.5.2 1v.8c0 .5-.1.8-.2 1-.1.2-.3.3-.6.3h-9.4c-.4 0-.6-.1-.8-.3zM141.4 19.4c0-.1.1-.4.3-.7l4-5.9-3.8-5.7c-.2-.3-.3-.5-.3-.7 0-.3.6-.5 1.7-.5h.9c.5 0 .8 0 1.1.1.2.1.4.2.6.4l1.6 2.6.4.6.5-.7 1.7-2.5c.1-.2.3-.3.6-.4.2-.1.6-.1 1.1-.1h.8c1.1 0 1.7.2 1.7.5 0 .1-.1.4-.3.7l-3.9 5.7 3.9 5.9c.2.3.3.5.3.7 0 .3-.6.5-1.7.5h-.9c-.5 0-.8 0-1.1-.1-.2-.1-.4-.2-.6-.4l-1.8-2.9-.3-.6-.3.6-1.9 2.9c-.1.2-.3.3-.6.4-.2.1-.6.1-1.1.1h-.8c-1.2-.1-1.8-.2-1.8-.5zM156.2 15.7V9.1h-.4c-.3 0-.5-.1-.6-.3-.1-.2-.2-.5-.2-1v-.4c0-.5.1-.8.2-1 .1-.2.3-.3.6-.3h.4l.3-2.5c.1-.6.6-.8 1.4-.8h.8c.9 0 1.3.3 1.3.8v2.5h1.3c.3 0 .5.1.6.3.1.2.2.5.2 1v.4c0 .5-.1.8-.2 1-.1.2-.3.3-.6.3H160v6.7c0 .4.1.7.2.9.2.2.4.3.7.3.1 0 .2 0 .4-.1.2 0 .3-.1.4-.1.2 0 .3.1.4.4l.3.9c.1.3.1.5.1.6 0 .9-.9 1.3-2.6 1.3-2.4 0-3.7-1.4-3.7-4.3zM165 19v-8.3c0-.8 0-1.4-.1-1.8s-.1-.9-.2-1.4c-.1-.2-.1-.4-.1-.6 0-.3.4-.5 1.1-.6.7-.1 1.4-.2 1.9-.2.3 0 .5.1.7.4.1.2.2.5.3.8.1.3.1.5.1.6.3-.6.7-1.1 1.2-1.5.5-.4 1-.5 1.7-.5.6 0 1 .1 1.2.4.2.3.3.6.3 1s-.1.8-.2 1.4c-.2.6-.4.8-.6.8-.1 0-.3 0-.6-.1s-.5-.1-.7-.1c-.5 0-.9.1-1.3.4-.4.3-.7.6-.9.9V19c0 .6-.5.8-1.6.8h-.7c-1 0-1.5-.2-1.5-.8zM175.1 19c-.6-.7-.9-1.6-.9-2.8 0-1.4.5-2.6 1.6-3.5 1-.9 3.1-1.4 6.1-1.4v-.9c0-.5-.2-.9-.5-1.1-.3-.2-.9-.4-1.6-.4-.6 0-1.1.1-1.6.2s-.9.3-1.2.4c-.4.2-.6.2-.6.2-.2 0-.4-.1-.6-.4l-.6-.9c-.2-.3-.2-.5-.2-.7 0-.3.2-.6.7-.9.4-.3 1.1-.5 1.8-.7.8-.2 1.6-.3 2.6-.3 2 0 3.5.4 4.4 1.2.9.8 1.4 1.9 1.4 3.2v4.9c0 .8 0 1.4.1 1.8 0 .4.1.9.2 1.4.1.2.1.4.1.6 0 .3-.4.5-1.1.6-.7.1-1.4.2-1.9.2-.3 0-.5-.1-.7-.4-.1-.3-.2-.5-.3-.8-.1-.3-.1-.5-.1-.6-.1.2-.3.4-.6.7-.3.3-.8.6-1.3.9-.6.3-1.2.4-1.9.4-1.6.1-2.6-.2-3.3-.9zm5.8-2.5c.4-.3.8-.7 1-1.2v-1.4c-2.5 0-3.7.6-3.7 1.9 0 .3.1.6.3.8.2.2.6.3 1 .3s.9-.1 1.4-.4zM190.4 18.3c-1.1-1.1-1.7-2.9-1.7-5.3s.6-4.2 1.7-5.4c1.1-1.2 2.8-1.8 5.2-1.8 1.1 0 2.1.2 3 .5.9.3 1.4.8 1.4 1.3 0 .3-.2.7-.5 1.2-.4.5-.7.8-.9.8-.1 0-.2-.1-.5-.2-.4-.2-.7-.3-1.1-.4-.3-.1-.8-.2-1.3-.2-1 0-1.8.3-2.3 1s-.7 1.7-.7 3 .2 2.4.7 3c.5.7 1.2 1 2.2 1 .5 0 .9 0 1.2-.1.4-.1.7-.2.9-.3.2-.1.4-.1.5-.2.3-.1.4-.2.5-.2.2 0 .4.1.6.4.2.3.4.5.6.9.2.3.2.6.2.7 0 .4-.3.8-.9 1.1-.6.3-1.3.5-2 .6-.7.1-1.3.2-1.8.2-2.2.1-3.9-.5-5-1.6zM202.6 15.7V9.1h-.4c-.3 0-.5-.1-.6-.3-.1-.2-.2-.5-.2-1v-.4c0-.5.1-.8.2-1 .1-.2.3-.3.6-.3h.4l.3-2.5c.1-.6.6-.8 1.4-.8h.8c.9 0 1.3.3 1.3.8v2.5h1.3c.3 0 .5.1.6.3.1.2.2.5.2 1v.4c0 .5-.1.8-.2 1-.1.2-.3.3-.6.3h-1.3v6.7c0 .4.1.7.2.9.2.2.4.3.7.3.1 0 .2 0 .4-.1.2 0 .3-.1.4-.1.2 0 .3.1.4.4l.3.9c.1.3.1.5.1.6 0 .9-.9 1.3-2.6 1.3-2.4 0-3.7-1.4-3.7-4.3zM222 19.3l-5.8-16.9c-.1-.2-.1-.4-.1-.5 0-.4.5-.6 1.6-.6h.9c.9 0 1.4.3 1.6.8l3.6 11.4.3.9h.1l.3-.9 3.7-11.4c.2-.5.7-.8 1.6-.8h.8c1.1 0 1.6.2 1.6.6 0 .1 0 .3-.1.5l-5.8 16.9c-.1.4-.6.6-1.5.6h-1.4c-.7-.1-1.2-.2-1.4-.6zM233.8 19c-.6-.7-.9-1.6-.9-2.8 0-1.4.5-2.6 1.6-3.5 1-.9 3.1-1.4 6.1-1.4v-.9c0-.5-.2-.9-.5-1.1-.3-.2-.9-.4-1.6-.4-.6 0-1.1.1-1.6.2s-.9.3-1.2.4c-.4.2-.6.2-.6.2-.2 0-.4-.1-.6-.4l-.6-.9c-.2-.3-.2-.6-.2-.8 0-.3.2-.6.7-.9.4-.3 1.1-.5 1.8-.7.8-.2 1.6-.3 2.6-.3 2 0 3.5.4 4.4 1.2.9.8 1.4 1.9 1.4 3.2V15c0 .8 0 1.4.1 1.8 0 .4.1.9.2 1.4.1.2.1.4.1.6 0 .3-.4.5-1.1.6-.7.1-1.4.2-1.9.2-.3 0-.5-.1-.7-.4-.1-.3-.2-.5-.3-.8-.1-.3-.1-.5-.1-.6-.1.2-.3.4-.6.7-.3.3-.8.6-1.3.9-.6.3-1.2.4-1.9.4-1.7.2-2.7-.1-3.3-.8zm5.7-2.5c.4-.3.8-.7 1-1.2v-1.4c-2.5 0-3.7.6-3.7 1.9 0 .3.1.6.3.8.2.2.6.3 1 .3.5 0 .9-.1 1.4-.4zM247.9 15.7V.8c0-.6.5-.8 1.6-.8h.7c1.1 0 1.6.3 1.6.8v15c0 .4.1.7.2.9.2.2.4.3.7.3.1 0 .2 0 .4-.1.2 0 .3-.1.4-.1.2 0 .3.1.4.4l.3.9c.1.3.1.5.1.6 0 .9-.9 1.3-2.6 1.3-2.5 0-3.8-1.4-3.8-4.3zM256.7 19c-.6-.7-1-1.8-1-3.2V6.9c0-.6.5-.8 1.6-.8h.7c1.1 0 1.6.3 1.6.8v8.3c0 .5.1.9.4 1.2.2.3.7.4 1.2.4s.9-.2 1.3-.5.7-.7.9-1.1V6.9c0-.6.5-.8 1.6-.8h.7c1.1 0 1.6.3 1.6.8v8.3c0 .8 0 1.4.1 1.8 0 .4.1.9.2 1.4.1.2.1.4.1.6 0 .3-.4.5-1.1.6-.7.1-1.4.2-1.9.2-.3 0-.5-.1-.7-.4-.1-.3-.2-.5-.3-.8-.1-.3-.1-.5-.1-.6-.4.6-1 1-1.7 1.4-.7.4-1.5.6-2.3.6-1.3 0-2.3-.3-2.9-1zM271.8 18.1c-1.1-1.2-1.7-2.9-1.7-5.1 0-2.5.6-4.3 1.7-5.4s2.7-1.7 4.8-1.7c2 0 3.4.6 4.4 1.9s1.4 2.9 1.4 4.9c0 .2-.2.5-.5.9-.4.4-.6.6-.8.6h-6.8c.1 1 .4 1.7.9 2.1.5.4 1.2.6 2.2.6.5 0 1-.1 1.4-.2.4-.1.8-.3 1.3-.4.3-.1.5-.2.6-.2.2 0 .4.1.6.4.2.3.4.5.6.9.2.3.2.6.2.7 0 .4-.3.7-.8 1-.6.3-1.2.5-2 .6-.8.1-1.4.2-2 .2-2.6.1-4.3-.5-5.5-1.8zm6.7-6.5c0-.8-.2-1.4-.5-1.9s-.8-.7-1.4-.7c-1.3 0-2.1.9-2.4 2.7h4.3zM283.9 19v-2.4c0-.6.5-.8 1.6-.8h.9c1.1 0 1.6.3 1.6.8V19c0 .6-.5.8-1.6.8h-.9c-1 0-1.6-.2-1.6-.8z"/></g></svg>
        </div>
        <div v-on:click="scrollDown('#content-1')" class="banner-prompt" :class="'bg-' + bannerColor">
          <icon name="ui-arrow-down" :color="bannerColor == 'black' ? 'white' : 'black'" size=24 /> 
        </div>
      </div>
    </section>
    
    <v-row v-for="(row, r) in rows"
      v-bind:content="row"
      v-bind:index="r"
      v-bind:key="'section-' + r"
    ></v-row>
    
  </div>
</template>

<script>
import Rows from '@/components/Rows.vue'

export default {
  name: 'Home',
  components: {
    'v-row': Rows
  },
  data() {
    return {
      banner: {
        size: {
          desktop: '',
          tablet: '',
          mobile: ''
        }
      },
      pageContent: null,
      loading: false
    }
  },
  computed: {
    apiURL() {
      return this.$store.state.apiURL;
    },
    rows() {
      var rows = [];
      
      if(this.pageContent) {
        rows = this.pageContent.content.rows;
      }
      
      return rows;
    },
    screenSize(){
      var screenSize = this.$store.getters.screenSize;
      return screenSize;
    },
    bannerColor(){
      var bannerColor = this.$store.state.menuColor;
      return bannerColor;
    },
    bannerImage(){
      var bannerImage = {
        desktop: this.banner.size.desktop,
        tablet: this.banner.size.tablet,
        mobile: this.banner.size.mobile
      };
      
      return bannerImage;
    },
    hideOnScroll() {
      var hideOnScroll = false;
      
      if(this.$store.state.scroll.current >= (this.$store.state.scroll.threshold + 10)) {
        hideOnScroll = true;
      }
      
      return hideOnScroll;
    },
    meta() {
      var meta = {
        title: "Home",
        url: "https://www.csbplab.com.au",
        desc: "",
        image: ""
      }
      
      return meta;
    }
  },
  beforeMount() {
    
    // Check if we have pre-loaded the data server-side
    if(window.__INITIAL_STATE__) {
      var init_state = JSON.parse(window.__INITIAL_STATE__);
      
      if('home' in init_state.data) {
        this.pageContent = init_state.data.home;
        
        // Select a random image
		this.randomImage();
      }
    }
    
    // If not, start loading the data client-side
    if(!this.pageContent) {
      this.loadContent();
    }
    
  },
  mounted() {
    
  },
  methods: {
    async loadContent() {
      // Start loading
      this.loading = true;
      
      // Request data from API
      await this.$axios.get(this.apiURL).then((response) => {
        this.pageContent = response.data.page;
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading the content for this page. Please reload page to try again.");
      });
      
      // Finish loading
      this.loading = false;
      
      // Select a random image
      this.randomImage();
    },
    preloadImages(srcs) {
      function loadImage(src) {
        
        return new Promise(function(resolve, reject) {
          var img = new Image();
          img.onload = function() {
            resolve(src);
          };
          img.onerror = img.onabort = function() {
            reject(src);
          };
          img.src = src;
        });
        
      }
      
      var promises = [];
      for (var i = 0; i < srcs.length; i++) {
        promises.push(loadImage(srcs[i]));
      }
      
      return Promise.all(promises);
    },
    randomImage() {
      var vm = this;
      
      // Select a random image, preload it and send to image holders
      var bannerKey = Math.floor(Math.random()*this.pageContent.banner.images.length);
      var bannerImages = this.pageContent.banner.images[bannerKey].sizes;
      var bannerColor = this.pageContent.banner.images[bannerKey].text_color;
      
      // Set text color
      this.$store.commit("setMenuColor",bannerColor);
      
      // Preload and set banner images
      this.preloadImages([
        bannerImages.desktop,
        bannerImages.tablet,
        bannerImages.mobile
      ]).then(function(imgs) {
        
        vm.banner.size.desktop = imgs[0];
        vm.banner.size.tablet = imgs[1];
        vm.banner.size.mobile = imgs[2];
      
      // eslint-disable-next-line
      }, function(errImg) {
        // eslint-disable-next-line
        console.log('There was an error loading the images.');
      });

    },
    scrollDown(targetEl) {
      var borderOffset = window.innerWidth >= 768 ? window.innerWidth * 0.02 : 0;
      this.$scrollTo(targetEl, 500, {offset: -borderOffset});
    }
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
}
</script>
